import React from 'react';
import styled from 'styled-components';

import { Menu, Dropdown, Icon } from 'antd';
import CreatinineIMG from '../../assets/images/creatinine.png';

const Creatinine = () => {
  let CreatinineImage;
  CreatinineImage = (
    <Menu style={{ width: '60rem', marginLeft: '-22rem' }}>
      <ul style={{ padding: '2rem', margin: '0 auto', listStyle: 'none' }}>
        <li style={{ fontSize: '1.5rem', textAlign: 'center', marginBottom: '1.2rem' }}>
          혈청, 혈액검사를 통한 수치를 기입해주세요. 보통 1자리~2자릿수로 나타납니다.
        </li>
        <img style={{ width: '100%' }} src={CreatinineIMG} alt="크레아티닌(Cr) 수치 안내" />
      </ul>
    </Menu>
  );
  return (
    <Wrap>
      <Dropdown overlay={CreatinineImage} trigger={['click']}>
        <a style={{ fontSize: '1.5rem', display: 'block', width: '16rem', margin: '0 auto' }}>
          <Icon type="question-circle" style={{ marginRight: '0.5rem' }} />
          도움이 필요하세요?
        </a>
      </Dropdown>
    </Wrap>
  );
};

const Wrap = styled.div`
  display: none;
  ${props => props.theme.device.md} {
    display: block;
  }
`;

export default Creatinine;
